// dictionary_form_controller.js
import ApplicationController from "./application_controller";

export default class DictionaryFormController extends ApplicationController {
  static targets = [
    // NOTE:- commented targets not required currently but kept in case client revert back to previous requirements 
    // 'crop_per_set_radio',
    // 'crop_per_line_radio',
    // 'crop_total_field',
    // 'crop_per_set_fee_field',
    'crop_per_line_fee_field',

    // 'sslice_per_set_radio',
    // 'sslice_per_line_radio',
    // 'sslice_total_field',
    // 'sslice_per_set_fee_field',
    'sslice_per_line_fee_field',

    // 'highlight_per_set_radio',
    // 'highlight_per_item_radio',
    // 'highlight_total_field',
    // 'highlight_per_set_fee_field',
    'highlight_per_item_fee_field',

    // 'typeo_per_set_radio',
    // 'typeo_per_character_radio',
    // 'typeo_total_field',
    // 'typeo_generated_total_field', // target used to give default fee string
    // 'typeo_per_set_fee_field',
    // 'typeo_per_generated_set_fee_field', // target being used only to toggle display of relevant field, not affecting any values just toggling field visibility
    'typeo_per_edited_character_fee_field', // target being used only to toggle display of relevant field, not affecting any values just toggling field visibility
    'typeo_per_generated_character_fee_field', // target being used only to toggle display of relevant field, not affecting any values just toggling field visibility
    'typeo_generated_character_field_container', // target being used only to toggle display of relevant div, not affecting any values just toggling div visibility
    // 'per_set_label', // target being used only to toggle display of relevant label div, not affecting any values just toggling label visibility
    // 'per_character_label', // // target being used only to toggle display of relevant label div, not affecting any values just toggling label visibility

    // 'typel_per_set_radio',
    // 'typel_per_character_radio',
    // 'typel_total_field',
    // 'typel_per_set_fee_field',
    'typel_per_character_fee_field',

    // 'totalFee'

    'newDictionaryRadio',
    'addVolumeRadio',
    'existingDictionarySelectContainer',
    'existingDictionarySelect',
    'titleTurkishContainer',
    'titleEnglishContainer',
    'collectionTitleTurkishContainer',
    'collectionTitleEnglishContainer',
    'currentVolumeField',
    'totalVolumesCountField',
    'multiVolumeCheckbox',
    'multiVolumeFieldsContainer',
    'sameAsTitleContainer',
    'sameAsTitleCheckbox',
    'titleTrField',
    'titleEnField',
    'collectionTitleTrField',
    'collectionTitleEnField',
    'testingCheckbox',
    'visibleCheckbox',
    'enablePageDirectionBtn',
    'pageDirectionSelect',
    'pageDirectionHidden',
    'pageDirectionWarning',
  ];

  initialize(){
    this.setsCount = this.element.dataset.setsCount;
    // NOTE:- commented methods not required currently but kept in case client revert back to previous requirements 
    //this.updateDictionaryFields()  
    // Initialize dictionary creation mode (new vs add-volume) and multi-volume UI state.
    this.setupDictionaryCreationMode()
    // When editing an existing dictionary, infer multi-volume UI from stored values.
    this.initializeMultiVolumeFromExistingValues()
    // Ensure volume fields visibility follows the multi-volume checkbox.
    this.syncMultiVolumeFieldsVisibility()
  }

  updateDictionaryFields(){
    this.#toggleFeeFeilds()
    this.#calculateAndDisplayFees()
  }

  #calculateAndDisplayFees(){
    // Calculating totals
    let noTotal = false;
    let totalCost = 0.0;

    if(this.crop_per_set_radioTarget.checked){
      let totalCropCost = Number(this.crop_per_set_fee_fieldTarget.value);
      totalCropCost = totalCropCost * this.setsCount;
      totalCost += totalCropCost
      this.crop_total_fieldTarget.value = `Total: ${totalCropCost}`
    } else {
      this.crop_total_fieldTarget.value = 'Total: --'
      noTotal = true
    }

    if(this.sslice_per_set_radioTarget.checked){
      let totalCropCost = Number(this.sslice_per_set_fee_fieldTarget.value);
      totalCropCost = totalCropCost * this.setsCount;
      totalCost += totalCropCost
      this.sslice_total_fieldTarget.value = `Total: ${totalCropCost}`
    } else {
      this.sslice_total_fieldTarget.value = 'Total: --'
      noTotal = true
    }

    if(this.highlight_per_set_radioTarget.checked){
      let totalCropCost = Number(this.highlight_per_set_fee_fieldTarget.value);
      totalCropCost = totalCropCost * this.setsCount;
      totalCost += totalCropCost
      this.highlight_total_fieldTarget.value = `Total: ${totalCropCost}`
    } else {
      this.highlight_total_fieldTarget.value = 'Total: --'
      noTotal = true
    }

    if(this.typeo_per_set_radioTarget.checked){
      let totalCropCost = Number(this.typeo_per_set_fee_fieldTarget.value);
      totalCropCost = totalCropCost * this.setsCount;
      totalCost += totalCropCost
      this.typeo_total_fieldTarget.value = `Total: ${totalCropCost}`
    } else {
      this.typeo_total_fieldTarget.value = 'Total: --'
      this.typeo_generated_total_fieldTarget.value = 'Total: --'
      noTotal = true
    }

    if(this.typel_per_set_radioTarget.checked){
      let totalCropCost = Number(this.typel_per_set_fee_fieldTarget.value);
      totalCropCost = totalCropCost * this.setsCount;
      totalCost += totalCropCost
      this.typel_total_fieldTarget.value = `Total: ${totalCropCost}`
    } else {
      this.typel_total_fieldTarget.value = 'Total: --'
      noTotal = true
    }

    if (noTotal){
      this.totalFeeTarget.value = '--'
    } else {
      this.totalFeeTarget.value = `Total: ${totalCost}`
    }
  }

  #toggleFeeFeilds(){
    // Shows or hides individual fee fields based on the selected fee type options.
    if(this.crop_per_set_radioTarget.checked){
      this.crop_per_set_fee_fieldTarget.classList.toggle('collapse', false)
      this.crop_per_line_fee_fieldTarget.classList.toggle('collapse', true)
    } else {
      this.crop_per_set_fee_fieldTarget.classList.toggle('collapse', true)
      this.crop_per_line_fee_fieldTarget.classList.toggle('collapse', false)
    }

    if(this.sslice_per_set_radioTarget.checked){
      this.sslice_per_set_fee_fieldTarget.classList.toggle('collapse', false)
      this.sslice_per_line_fee_fieldTarget.classList.toggle('collapse', true)
    } else {
      this.sslice_per_set_fee_fieldTarget.classList.toggle('collapse', true)
      this.sslice_per_line_fee_fieldTarget.classList.toggle('collapse', false)
    }

    if(this.highlight_per_set_radioTarget.checked){
      this.highlight_per_set_fee_fieldTarget.classList.toggle('collapse', false)
      this.highlight_per_item_fee_fieldTarget.classList.toggle('collapse', true)
    } else {
      this.highlight_per_set_fee_fieldTarget.classList.toggle('collapse', true)
      this.highlight_per_item_fee_fieldTarget.classList.toggle('collapse', false)
    }

    if(this.typeo_per_set_radioTarget.checked){
      this.typeo_per_set_fee_fieldTarget.classList.toggle('collapse', false)
      this.per_set_labelTarget.classList.toggle('collapse', false) 
      this.per_character_labelTarget.classList.toggle('collapse', true) 
      this.typeo_per_generated_set_fee_fieldTarget.classList.toggle('collapse', true)
      this.typeo_per_edited_character_fee_fieldTarget.classList.toggle('collapse', true) 
      this.typeo_per_generated_character_fee_fieldTarget.classList.toggle('collapse', true)  
      this.typeo_generated_character_field_containerTarget.classList.toggle('collapse', true)
    } else {
      this.per_set_labelTarget.classList.toggle('collapse', true) 
      this.per_character_labelTarget.classList.toggle('collapse', false)
      this.typeo_per_set_fee_fieldTarget.classList.toggle('collapse', true)
      this.typeo_per_generated_set_fee_fieldTarget.classList.toggle('collapse', true)
      this.typeo_per_edited_character_fee_fieldTarget.classList.toggle('collapse', false)
      this.typeo_per_generated_character_fee_fieldTarget.classList.toggle('collapse', false)
      this.typeo_generated_character_field_containerTarget.classList.toggle('collapse', false)
    }

    if(this.typel_per_set_radioTarget.checked){
      this.typel_per_set_fee_fieldTarget.classList.toggle('collapse', false)
      this.typel_per_character_fee_fieldTarget.classList.toggle('collapse', true)
    } else {
      this.typel_per_set_fee_fieldTarget.classList.toggle('collapse', true)
      this.typel_per_character_fee_fieldTarget.classList.toggle('collapse', false)
    }
  }

  // Decides whether we are creating a brand new dictionary or adding a volume and adjusts UI.
  setupDictionaryCreationMode(){
    if(!this.hasNewDictionaryRadioTarget || !this.hasAddVolumeRadioTarget){
      return
    }

    if(this.newDictionaryRadioTarget.checked){
      this.showCreateNewDictionaryMode()
    } else {
      this.showAddVolumeMode()
    }
  }

  // When editing an existing dictionary (no creation mode radios), derive multi-volume
  // checkbox state from current total volume count for better UX.
  initializeMultiVolumeFromExistingValues(){
    if(this.hasNewDictionaryRadioTarget && this.hasAddVolumeRadioTarget){
      return
    }

    if(!this.hasMultiVolumeCheckboxTarget || !this.hasTotalVolumesCountFieldTarget){
      return
    }

    const totalValue = parseInt(this.totalVolumesCountFieldTarget.value, 10)
    if(!isNaN(totalValue) && totalValue > 1){
      this.multiVolumeCheckboxTarget.checked = true
    } else {
      this.multiVolumeCheckboxTarget.checked = false
    }
  }

  creationModeChanged(event){
    if(this.newDictionaryRadioTarget.checked){
      this.showCreateNewDictionaryMode()
    } else {
      this.showAddVolumeMode()
    }
  }

  showCreateNewDictionaryMode(){
    if(this.hasExistingDictionarySelectContainerTarget){
      this.existingDictionarySelectContainerTarget.classList.add('collapse')
    }

    if(this.hasTitleTurkishContainerTarget){
      this.titleTurkishContainerTarget.classList.remove('collapse')
    }

    if(this.hasTitleEnglishContainerTarget){
      this.titleEnglishContainerTarget.classList.remove('collapse')
    }

    if(this.hasMultiVolumeCheckboxTarget){
      this.multiVolumeCheckboxTarget.disabled = false
      this.multiVolumeCheckboxTarget.checked = false
    }

    // Sync volume fields visibility after unchecking the checkbox.
    // This will also hide collection title fields since multi-volume is unchecked.
    this.syncMultiVolumeFieldsVisibility()
  }

  showAddVolumeMode(){
    if(this.hasExistingDictionarySelectContainerTarget){
      this.existingDictionarySelectContainerTarget.classList.remove('collapse')
    }

    // Keep title fields visible in add-volume mode - user can edit them
    if(this.hasTitleTurkishContainerTarget){
      this.titleTurkishContainerTarget.classList.remove('collapse')
    }

    if(this.hasTitleEnglishContainerTarget){
      this.titleEnglishContainerTarget.classList.remove('collapse')
    }

    if(this.hasMultiVolumeCheckboxTarget){
      this.multiVolumeCheckboxTarget.checked  = true
      this.multiVolumeCheckboxTarget.disabled = true
    }

    // Sync visibility - this will show collection fields and volume fields since multi-volume is checked
    this.syncMultiVolumeFieldsVisibility()
  } 

  // Handle change in the existing dictionary selection dropdown:
  // updates title, current volume, total volume count, and multi-volume UI.
  handle_existing_dictionary_selection(event){
    if(!this.hasExistingDictionarySelectTarget){
      return
    }

    const selectedOption = this.existingDictionarySelectTarget.selectedOptions[0]
    if(!selectedOption){
      return
    }

    const selectedTitle = selectedOption.value
    const selectedTitleTr = selectedOption.getAttribute('data-collection-title-tr') || ''
    const existingVolumesData = selectedOption.getAttribute('data-existing-volumes') || ''
    const totalVolumesData = selectedOption.getAttribute('data-total-volumes')

    // Populate collection title fields with the selected collection's titles
    // User can edit these fields if needed
    if(this.hasCollectionTitleEnFieldTarget){
      this.collectionTitleEnFieldTarget.value = selectedTitle
    }
    if(this.hasCollectionTitleTrFieldTarget){
      this.collectionTitleTrFieldTarget.value = selectedTitleTr
    }

    // Update current volume field with the next available volume number.
    if(this.hasCurrentVolumeFieldTarget){
      const volInput = this.currentVolumeFieldTarget
      if(existingVolumesData){
        const existingVolumes = existingVolumesData.split(',').map(v => parseInt(v, 10)).filter(v => !isNaN(v))
        let suggested = 1
        if(existingVolumes.length > 0){
          const maxVol = Math.max.apply(null, existingVolumes)
          suggested = maxVol + 1
        }
        volInput.value = suggested
      }
    }

    // Update total volume count field with the total number of volumes in the selected dictionary.
    if(this.hasTotalVolumesCountFieldTarget){
      const totalInput = this.totalVolumesCountFieldTarget
      if(totalVolumesData){
        totalInput.value = totalVolumesData
      }
    }

    if(this.hasMultiVolumeCheckboxTarget){
      this.multiVolumeCheckboxTarget.checked = true
    }
    this.syncMultiVolumeFieldsVisibility()
  }

  syncMultiVolumeFieldsVisibility(){
    if(!this.hasMultiVolumeFieldsContainerTarget || !this.hasMultiVolumeCheckboxTarget){
      return
    }

    const visible = this.multiVolumeCheckboxTarget.checked

    // Show/hide volume number fields
    this.multiVolumeFieldsContainerTarget.classList.toggle('collapse', !visible)

    // Show/hide collection title fields when multi-volume is checked
    if(this.hasCollectionTitleTurkishContainerTarget){
      this.collectionTitleTurkishContainerTarget.classList.toggle('collapse', !visible)
    }

    if(this.hasCollectionTitleEnglishContainerTarget){
      this.collectionTitleEnglishContainerTarget.classList.toggle('collapse', !visible)
    }

    if(this.hasSameAsTitleContainerTarget){
      this.sameAsTitleContainerTarget.classList.toggle('collapse', !visible)
    }
  }

  // When "Same as Dictionary Title" is checked, copy collection title values into title fields.
  // When unchecked, clear the title fields
  handleSameAsTitleToggle(){
    if(!this.hasSameAsTitleCheckboxTarget) return

    if(this.sameAsTitleCheckboxTarget.checked){
      this.syncCollectionTitlesToTitles()
    } else {
      // Clear collection title fields when checkbox is unchecked
      if(this.hasTitleTrFieldTarget){
        this.titleTrFieldTarget.value = ''
      }
      if(this.hasTitleEnFieldTarget){
        this.titleEnFieldTarget.value = ''
      }
    }
  }

  // Called on input in title fields; keeps collection titles in sync when checkbox is checked.
  handleTitleInput(){
    if(!this.hasSameAsTitleCheckboxTarget || !this.sameAsTitleCheckboxTarget.checked) return

    this.syncCollectionTitlesToTitles()
  }

  syncCollectionTitlesToTitles(){
    if(this.hasCollectionTitleTrFieldTarget && this.hasTitleTrFieldTarget){
      this.titleTrFieldTarget.value = this.collectionTitleTrFieldTarget.value
    }
    if(this.hasCollectionTitleEnFieldTarget && this.hasTitleEnFieldTarget){
      this.titleEnFieldTarget.value = this.collectionTitleEnFieldTarget.value
    }
  }

  // Mutually exclusive visibility checkboxes
  toggleTesting(event) {
    if (event.target.checked) {
      // If testing is checked, uncheck visible
      this.visibleCheckboxTarget.checked = false
    }
  }

  toggleVisible(event) {
    if (event.target.checked) {
      // If visible is checked, uncheck testing
      this.testingCheckboxTarget.checked = false
    }
  }

  // Active dictionary: unlock page direction for this Save and show the inline warning.
  enablePageDirectionChange() {
    if (!this.hasPageDirectionSelectTarget) return

    this.pageDirectionSelectTarget.disabled = false
    if (this.hasPageDirectionHiddenTarget) {
      // Disabled selects are not submitted; disable hidden so the select value is used.
      this.pageDirectionHiddenTarget.disabled = true
    }
    if (this.hasEnablePageDirectionBtnTarget) {
      this.enablePageDirectionBtnTarget.disabled = true
    }
    if (this.hasPageDirectionWarningTarget) {
      this.pageDirectionWarningTarget.classList.remove('d-none')
    }
  }
}

